import { ReactComponent as AudiomackColorLight } from 'fym-shared/src/music-services/assets/images/audiomack-color-light.svg';
import { ReactComponent as AudiomackColorDark } from 'fym-shared/src/music-services/assets/images/audiomack-color-dark.svg';
import { ReactComponent as AudiomackColorLightPadding } from 'fym-shared/src/music-services/assets/images/audiomack-color-light-padding.svg';
import { ReactComponent as AudiomackColorDarkPadding } from 'fym-shared/src/music-services/assets/images/audiomack-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const audiomackImages: MusicServiceImages = {
  logoColor: {
    light: AudiomackColorLight,
    dark: AudiomackColorDark,
  },
  logoColorPadding: {
    light: AudiomackColorLightPadding,
    dark: AudiomackColorDarkPadding,
  },
};
